import React from "react";
import { INPUT_BOX_STYLES } from "asset/base-theme";
import { generateClasses } from "util/Util";
import { useTranslation } from "react-i18next";
import BasePassword, { IBaseInputPasswordProps } from "component/base/BasePassword";
import { IInputCommonStyleProps } from "component/interface/Input";

interface IInputPasswordProps extends IBaseInputPasswordProps, IInputCommonStyleProps {}

const InputPasswordWithoutMemo: React.FC<IInputPasswordProps> = (props: any) => {
  const {
    value,
    onChange,
    onChangeTextState,
    name,
    placeholder,
    label,
    validation,
    disabled,
    variantType,
    styleObj,
    ...BaseInputProps
  } = props;

  const getClassNames = () => {
    const styleObject = {
      ...INPUT_BOX_STYLES,
      overrideStyle: styleObj,
      overrideClasses: props.className,
      isDisabled: props.disabled,
      isInvalid: props.validation ? true : false,
      removeStyleProperty: [],
      removeClasses: [],
    };

    return generateClasses(styleObject, variantType);
  };

  const { t } = useTranslation();
  const placeholderLabel = t(placeholder);

  return (
    <>
      <BasePassword
        {...BaseInputProps}
        className={getClassNames()}
        value={value}
        promptLabel=""
        mediumLabel="Medium"
        strongRegex={`^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{12,})`}
        onChange={onChange}
        onChangeTextState={onChangeTextState}
        name={name}
        placeholder={placeholderLabel}
        disabled={disabled}
        label={label}
        validation={validation}
      />
    </>
  );
};

// ----------- memoization -------------------- //
const InputPassword = React.memo(InputPasswordWithoutMemo);

// ----------- redux wiring ------------------- //

// ----------- exports ------------------------ //
export default InputPassword;
